"use client";

import { c as _c } from "react/compiler-runtime";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import { Children, type ReactNode } from "react";
import DropCurationButton from "../DropCurationButton";
import WaveDropReactions from "../WaveDropReactions";
import { ParticipationDropRatings } from "./ParticipationDropRatings";
interface ParticipationDropFooterProps {
  readonly drop: ExtendedDrop;
  readonly voteAction?: ReactNode;
}
export default function ParticipationDropFooter(t0) {
  const $ = _c(24);
  const {
    drop,
    voteAction
  } = t0;
  const {
    canShowVote
  } = useDropInteractionRules(drop);
  const canShowCuration = drop.context_profile_context?.curatable ?? false;
  const hasRatings = drop.raters_count > 0;
  const hasReactions = drop.reactions.length > 0;
  let t1;
  if ($[0] !== voteAction) {
    t1 = Children.toArray(voteAction);
    $[0] = voteAction;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const normalizedVoteAction = t1;
  const hasVoteAction = normalizedVoteAction.length > 0;
  const hasPrimaryActions = canShowCuration || hasVoteAction;
  const shouldShowVoteFooter = canShowVote && (hasRatings || hasPrimaryActions);
  const shouldShowRatingsOnlyFooter = !canShowVote && hasRatings;
  const shouldShowReactionsFooter = hasReactions || !canShowVote && canShowCuration;
  let t2;
  if ($[2] !== canShowCuration || $[3] !== drop || $[4] !== hasPrimaryActions || $[5] !== hasRatings || $[6] !== normalizedVoteAction || $[7] !== shouldShowVoteFooter) {
    t2 = shouldShowVoteFooter && <div className="tw-mt-4 tw-@container sm:tw-ml-[3.25rem]" onClick={_temp}><div className="tw-flex tw-flex-col tw-gap-x-4 tw-gap-y-3 @[700px]:tw-flex-row @[700px]:tw-items-center @[700px]:tw-justify-between">{hasRatings && <div className="tw-px-4"><ParticipationDropRatings drop={drop} rank={drop.rank} /></div>}{hasPrimaryActions && <div className="tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-1.5 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-iron-800 tw-px-6 tw-pt-4 @[700px]:tw-ml-auto @[700px]:tw-w-auto @[700px]:tw-border-none @[700px]:tw-px-4 @[700px]:tw-pt-0"><DropCurationButton dropId={drop.id} waveId={drop.wave.id} isCuratable={canShowCuration} isCurated={drop.context_profile_context?.curated ?? false} />{normalizedVoteAction}</div>}</div></div>;
    $[2] = canShowCuration;
    $[3] = drop;
    $[4] = hasPrimaryActions;
    $[5] = hasRatings;
    $[6] = normalizedVoteAction;
    $[7] = shouldShowVoteFooter;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== drop || $[10] !== shouldShowRatingsOnlyFooter) {
    t3 = shouldShowRatingsOnlyFooter && <div className="tw-ml-[3.25rem] tw-mt-4 tw-px-4"><ParticipationDropRatings drop={drop} rank={drop.rank} /></div>;
    $[9] = drop;
    $[10] = shouldShowRatingsOnlyFooter;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== canShowCuration || $[13] !== canShowVote || $[14] !== drop || $[15] !== shouldShowReactionsFooter) {
    t4 = shouldShowReactionsFooter && <div className="tw-ml-[3.25rem] tw-mt-4 tw-flex tw-w-[calc(100%-3.25rem)] tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-1 tw-px-4 tw-pb-4">{!canShowVote && <DropCurationButton dropId={drop.id} waveId={drop.wave.id} isCuratable={canShowCuration} isCurated={drop.context_profile_context?.curated ?? false} />}<WaveDropReactions drop={drop} /></div>;
    $[12] = canShowCuration;
    $[13] = canShowVote;
    $[14] = drop;
    $[15] = shouldShowReactionsFooter;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== shouldShowReactionsFooter) {
    t5 = !shouldShowReactionsFooter && <div className="tw-pb-4" />;
    $[17] = shouldShowReactionsFooter;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t2 || $[20] !== t3 || $[21] !== t4 || $[22] !== t5) {
    t6 = <>{t2}{t3}{t4}{t5}</>;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
}
function _temp(e) {
  return e.stopPropagation();
}